import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ titleColor, subtitleColor }) => ({
    thRoot: 'bg-darkGrey h-full isolate overflow-hidden relative rounded-12',
    thHeader: 'flex absolute justify-center items-start mt-20 text-center top-0 w-full',
    thImage: 'opacity-75 transition-transform duration-250 ease-in transform hover:scale-105',
    thHeaderItem: ({ textColor = COLORS.BLACK, backgroundColor = COLORS.SAFFRON }) =>
      classnames(
        `bg-${backgroundColor}`,
        'm-0 mx-5 max-w-1/2 rounded-pill px-10 py-5 font-sans text-12 font-bold leading-1',
        `text-${textColor}`,
      ),
    thTitle: classnames('mb-10 text-center font-brand text-22 font-bold leading-tight', {
      [`text-${titleColor || COLORS.WHITE}`]: true,
    }),
    thSubTitle: classnames('m-0 pb-15 text-center text-14', {
      [`text-${subtitleColor || COLORS.WHITE}`]: true,
    }),
    thFooter: 'absolute bottom-0 p-10 pb-20 transition-transform duration-250 ease-in w-full',
  }),
};
